<template>
  <div class="topVert" id="reseauxPersonnalise">
    <div class="columns is-marginless">
      <div class="circleStyle">
        <b-icon
        icon="circle"
        size="is-small">
        </b-icon>
      </div>
      <h2 class="has-text-weight-bold has-text-link">
        Proposition réseau(x) personnalisé(s)
      </h2>
    </div>
    <div class="colomn"
      v-for="(reseauxPersonnalise, index) in detailReseauxPersonnalise"
      :key="index">
      <h3 class="has-text-default has-text-weight-bold topBleu bottomVert">
        {{reseauxPersonnalise.libelle}}
      </h3>
      <app-carte-reseaux-personnalise
        :faces="reseauxPersonnalise.faces"
        :couleur="reseauxPersonnalise.couleur"/>
      <app-info-reseaux-personnalise :infoReseauxPersonnalise="reseauxPersonnalise"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import infoReseauxPersonnalise from './infoReseauxPersonnalise';
import carteReseauxPersonnalise from './carteReseauxPersonnalise';

export default {
  name: 'index',
  props: ['detailReseauxPersonnalise'],
  components: {
    appInfoReseauxPersonnalise: infoReseauxPersonnalise,
    appCarteReseauxPersonnalise: carteReseauxPersonnalise,
  },
  computed: {
    ...mapGetters(['getMaSelection']),
    detailReseauxPersonnaliseFilter() {
      const data = this.detailReseauxPersonnalise.filter(d =>
        !d.extensionOpportunite.reseauPersoGuid);
      if (this.getMaSelection) {
        return data.filter(el => el.select);
      }
      return data;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxPersonnalise/index.vue